module.exports = __webpack_public_path__ + "img/active2021ts.f33939fb.png";